import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ModalContent } from './modal-content/modal-content.style.js';
import { ModalFooter } from './modal-footer/modal-footer.component.js';
import { ModalFooterStacked } from './modal-footer-stacked/modal-footer-stacked.component.js';
import { ModalHeader } from './modal-header/modal-header.component.js';
import { ModalHeaderCentered } from './modal-header-centered/modal-header-centered.component.js';
import { Overlay, Dialog } from './modal.style.js';

const Modal = props => {
    const { 'aria-label': ariaLabel, className = '', children, size = 'medium' } = props, rest = __rest(props, ['aria-label', "className", "children", "size"]);
    return (jsx(Overlay, Object.assign({ className: className }, rest, { "aria-label": "overlay" }, { children: jsx(Dialog, Object.assign({ "aria-label": ariaLabel, size: size }, { children: children }), void 0) }), void 0));
};
Modal.Header = ModalHeader;
Modal.HeaderCentered = ModalHeaderCentered;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.FooterStacked = ModalFooterStacked;

export { Modal };
